import React, { useState, useEffect } from "react";
import { HeaderGovtWrapper, LeftGovtContent, RightGovtContent } from "../StyledComponent";
import { AwasBandhuURL, GovtStripImages } from "../data";
import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
// import { useThemeContext } from "../../AccessibilityComp/LandingPageThemeProvider";

function GovtStrip() {
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const { t } = useTranslation();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;

    if (currentScrollPos > 0) {
      setVisible(false);
    } else {
      setVisible(true);
    }
    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  });

  // const { isDarkMode } = useThemeContext();

  //   const theme = createTheme({
  //     palette: {
  //       mode: isDarkMode ? 'dark' : 'light',  // or dark
  //       primary: {
  //         main: isDarkMode ? '#343434' : 'rgb(237, 240, 244)',
  //       },
  //       awasbandhu: {
  //         primary: {
  //           main: isDarkMode ? '#343434' : 'rgb(237, 240, 244)',// your custom color
  //         },
  //       },

  //     },
  //   });

  return (
    // <MuiThemeProvider theme={theme}>
    <React.Fragment>
      <HeaderGovtWrapper>
        {/* <LeftGovtContent>
                {AwasBandhuURL.map((image, index) => (
                    <a key={index} href={image.link} target="_blank" rel="noopener noreferrer">
                        <img src={image.src} alt={image.alt} />
                    </a>
                ))}
            </LeftGovtContent> */}

        <LeftGovtContent>
          <div style={{ display: "flex" }}>
            <img src={urlImg} alt="Uttar-Pradesh-Logo" class="uplogo" />
            <div class="container-heading">
              <h1 class="headerup">{t("FASTPAS.HOME.GOV_HEADER.DEPARTMENT_NAME")}</h1>
              <h2 class="headerup">{t("FASTPAS.HOME.GOV_HEADER.GOVERNMENT_NAME")}</h2>
            </div>
          </div>
        </LeftGovtContent>
        <RightGovtContent className="preLogo">
          {GovtStripImages.map((image, index) => (
            <a key={index} href={image.link} target="_blank" rel="noopener noreferrer">
              <img src={image.src} alt={image.alt} />
            </a>
          ))}
        </RightGovtContent>
      </HeaderGovtWrapper>
    </React.Fragment>
    // </MuiThemeProvider>
  );
}

export default GovtStrip;
